const customDecodeUri = (str) => {
  try {
    str = decodeURI(str)
  } catch (error) {
    try {
      str = decodeURI(str.replace(/%/g, '%25'))
    } catch (error) {}
  }
  return str
}

module.exports = customDecodeUri
